import { initStorageInstance } from './index'
import {
  NAMEPLATE_REISSUE_ADDRESS_INFO_KEY,
  NAMEPLATE_REISSUE_MODIFY_ADDRESS_INFO_KEY,
} from './constant'

export const NameReissueAddressInfoStorage = initStorageInstance(
  NAMEPLATE_REISSUE_ADDRESS_INFO_KEY,
  {
    type: 'localStorage',
    verifyMobile: true,
  }
)

export const NameReissueModifyAddressInfoStorage = initStorageInstance(
  NAMEPLATE_REISSUE_MODIFY_ADDRESS_INFO_KEY,
  {
    type: 'sessionStorage',
    verifyMobile: true,
  }
)
